import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorText } = theme();

  return StyleSheet.create({
    buttons: {
      flexDirection: "row",
    },
    pills: {
      elevation: 5,
      shadowColor: colorText,
      shadowOffset: {
        width: 0,
        height: 3,
      },
      shadowOpacity: 0.05,
      shadowRadius: 19,
    },
  });
};

export { style };
